import { useRouter } from 'next/router'
import { getServerSideProps as getPropsMainPage } from '../../graphql/storiesAndInvestigations'
import { getServerSideProps as getPropsFilteredStories, pageCount } from '../../graphql/filteredStories'
import AppChrome from '../../components/AppChrome'
import Hero from '../../components/Hero'
import FeaturedInvestigationWithStories from '../../components/FeaturedInvestigationWithStories'
import StoriesBlock from '../../components/Stories'
import InvestigationsCarousel from '../../components/InvestigationsCarousel'

type GroupedTags = {
  [key: string]: {
    id: number,
    slug: string,
    title: string,
  },
}

const getSelectedTags = ( tags, query ): GroupedTags => Object.keys( tags ).reduce(
  ( reduced, tagGroupHandle ) => ( {
    ...reduced,
    [ tagGroupHandle ]: (
      query[ tagGroupHandle ]
        && tags[ tagGroupHandle ].find( t => t.slug === query[ tagGroupHandle ] )
    ) || null,
  } ),
  {},
)

function Stories( {
  entry: storiesAndInvestigations,
  stories,
  storiesCount,
  storyTags,
  investigations,
} ) {
  const investigation = storiesAndInvestigations
    .featuredInvestigationWithStories?.[ 0 ]?.investigation?.[ 0 ]
  const featuredStories = storiesAndInvestigations.featuredInvestigationWithStories?.[ 0 ]?.stories

  const { query } = useRouter()
  const page = query?.page as string | null
  const shouldShowFeatured = !query?.location && !query?.topic && !query?.page
  const tags = storyTags

  const tagTitles = Object.values( getSelectedTags( tags, query ) )
    .map( t => t?.title )
    .filter( t => !!t )
    .join( ', ' )

  const paginationTitle = ( page && parseInt( page, 10 ) > 1 ) ? `Page ${ page }` : ''

  return (
    <AppChrome
      metaTags={ {
        url: `https://${ process.env.NEXT_PUBLIC_APP_HOSTNAME }/stories`,
        title: `${ storiesAndInvestigations.title }${ tagTitles && `: ${ tagTitles }` }${ paginationTitle && `, ${ paginationTitle }` } — Finance Uncovered`,
      } }
    >
      <Hero
        title={ storiesAndInvestigations.title }
        intro={ storiesAndInvestigations.introCopy }
      />
      { shouldShowFeatured && investigation && (
        <FeaturedInvestigationWithStories
          investigation={ investigation }
          stories={ featuredStories }
        />
      ) }
      <StoriesBlock 
        stories={ stories } 
        tags={ tags }
        pageCount={ pageCount( storiesCount ) }
      />
      { shouldShowFeatured && investigations && (
        <InvestigationsCarousel
          sectionTitle="More Investigations"
          investigations={ investigations }
        />
      ) }
    </AppChrome>
  )
}

export const getServerSideProps = async ctx => {
  const { query } = ctx

  if ( !Object.keys( query ).length ) {
    return getPropsMainPage( ctx )
  }
  
  return getPropsFilteredStories( ctx )
}

export default Stories
